(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.SolutionBuilderAgent:mxSettingViewhelpEditor
	 * @module mx.SolutionBuilderAgent
	 * @restrict 'E'
	 * @description .
	 *
	 * @requires $http
	 * @requires {@ref mx.shell.Config mx.shell.Http}
	 * @requires {@ref mx.shell.Config mx.shell.Config}
	 * @requires {@ref mx.internationalization mx.internationalization}
	 *
	 * @param {Integer} value= The source type to display an associated article with the given view.
	 * @param {String} value2= The value used in identification of an article.
	 *
	 * @usage <mx-setting-viewhelp-editor></mx-setting-viewhelp-editor>
	 */

	angular.module('mx.SolutionBuilderAgent').component('mxSettingViewhelpEditor', {
		bindings: {
			value: '=',
			value2: '=',
		},
		controller: MxSettingViewhelpEditorCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-setting-viewhelp-editor/mx-setting-viewhelp-editor.html',
	});

	MxSettingViewhelpEditorCtrl.$inject = ['$scope', '$http', 'mx.shell.Http', 'mx.shell.Config', 'mx.internationalization'];

	function MxSettingViewhelpEditorCtrl($scope, $http, mxHttp, mxConfig, i18n) {
		var vm = this;
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-setting-viewhelp-editor');
		vm.hashtags = [];
		vm.hashtag = null;
		vm.onlineHashtags = [];
		vm.onlineHashtag = null;
		vm.localKBArticleID = '';
		vm.localKBArticleObjID = '';
		vm.onlineKBArticle = '';
		vm.onlineKBArticleFound = '';

		var _helpSourceType = '0';
		var _localKBArticleValue = '';
		var _onlineKBArticleValue = '';
		var _onlineHelpRestHosts = '';
		var _initHashtag = '';

		vm.$onInit = function () {
			var panels = [];
			panels.push({ id: '135DFB2D-D36B-4DC3-857F-470E0609BEEA', title: vm.i18n.None, name: '0', visible: true, disabled: false, position: 1, count: '', description: '' });
			panels.push({
				id: '1117709A-8A5F-4CCA-A4DB-AAE87A381B6F',
				title: vm.i18n.KBArticle,
				name: '1',
				visible: true,
				disabled: false,
				position: 2,
				count: '',
				description: '',
			});
			panels.push({
				id: '0A05A299-F5FA-4633-A627-8EAE573D993C',
				title: vm.i18n.M42OnlineHelp,
				name: '2',
				visible: false,
				disabled: false,
				position: 3,
				count: '',
				description: '',
			});
			panels.push({
				id: '440817BE-B63A-41E6-972B-1D9CDAE83ADA',
				title: vm.i18n.ExternalURL,
				name: '3',
				visible: true,
				disabled: false,
				position: 4,
				count: '',
				description: '',
			});
			vm.panels = panels;

			vm.hiddenPanels = mxConfig.settings.productName !== 'Workspace Management' ? '1' : '';
			_onlineHelpRestHosts = mxConfig.settings.restHosts.onlineHelp + '/api/kbarticle/Check';

			_helpSourceType = vm.value + '';
			if (vm.value2) {
				switch (vm.helpSourceType) {
					case '1':
						{
							var _obj1 = JSON.parse(vm.value2);
							if (typeof _obj1 === 'object') {
								vm.localKBArticleID = _obj1.Id;
								_initHashtag = _obj1.Hashtag;
							}
						}
						break;
					case '2':
						{
							var _obj2 = JSON.parse(vm.value2);
							if (typeof _obj2 === 'object') {
								vm.onlineKBArticle = _obj2.Title;
								_initHashtag = _obj2.Hashtag;
							}
						}
						break;
				}
			}

			$scope.$watchCollection('vm.localKBArticleObjID', function (newVal) {
				if (vm.value + '' === '1') {
					vm.hashtags = [];
					vm.hashtag = null;
					vm.value2 = '';

					if (newVal) {
						vm.value2 = _localKBArticleValue = '{"Id":"' + vm.localKBArticleID + '","ObjID":"' + newVal + '"}';
						_loadHeadings(newVal, false);
					}
				}
			});

			$scope.$watchCollection('vm.hashtag', function (newVal) {
				if (vm.value + '' === '1' && vm.value2) {
					var obj = JSON.parse(vm.value2);
					delete obj.Hashtag;
					if (newVal) {
						obj.Hashtag = newVal;
					}

					vm.value2 = _localKBArticleValue = JSON.stringify(obj);
				}
			});

			$scope.$watchCollection('vm.onlineKBArticle', function (newVal) {
				if (vm.value + '' === '2') {
					vm.onlineHashtags = [];
					vm.onlineHashtag = null;
					vm.value2 = '';
					vm.onlineKBArticleFound = '';

					if (newVal) {
						$http.get(_onlineHelpRestHosts + '/?data=' + encodeURIComponent(newVal)).then(function (response) {
							if (typeof response === 'object' && response.data.ObjectID) {
								vm.value2 = _onlineKBArticleValue = '{"Title":"' + newVal + '","ObjID":"' + response.data.ObjectID + '"}';
								vm.setValidity('kbArticleNotFound', true);
								vm.onlineKBArticleFound = i18n.getFormatted(
									'solutionBuilderAgent.components.mx-setting-viewhelp-editor.kbArticleFound',
									newVal,
									response.data.Subject
								);
								_loadHeadings(response.data.ObjectID, true);
							} else {
								vm.setValidity('kbArticleNotFound', false);
							}
						});
					}
				}
			});

			$scope.$watchCollection('vm.onlineHashtag', function (newVal) {
				if (vm.value + '' === '2' && vm.value2) {
					var obj = JSON.parse(vm.value2);
					delete obj.Hashtag;
					if (newVal) {
						obj.Hashtag = newVal;
					}

					vm.value2 = _onlineKBArticleValue = JSON.stringify(obj);
				}
			});
		};

		Object.defineProperty(vm, 'helpSourceType', {
			get: function () {
				return _helpSourceType;
			},
			set: function (newVal) {
				if (_helpSourceType !== newVal) {
					switch (newVal) {
						case '1':
							{
								vm.value2 = _localKBArticleValue;
							}
							break;
						case '2':
							{
								vm.value2 = _onlineKBArticleValue;
							}
							break;
						default: {
							vm.value2 = '';
						}
					}
				}
				vm.value = _helpSourceType = newVal;
			},
		});

		function _loadHeadings(kbObjId, isOnline) {
			if (isOnline) {
				$http.get(mxConfig.settings.restHosts.onlineHelp + '/api/kbarticle/' + kbObjId + '/html').then(function (response) {
					if (typeof response === 'object' && response.data) {
						_setHashtags(response.data.Hashtags, isOnline);
					}
				});
			} else {
				mxHttp.get('api/kbarticle/' + kbObjId + '/html').then(function (data) {
					if (typeof data === 'object' && Array.isArray(data.Hashtags)) {
						_setHashtags(data.Hashtags, isOnline);
					}
				});
			}
		}

		function _setHashtags(hashtags, isOnline) {
			if (Array.isArray(hashtags)) {
				var selectedHasgTag = null;
				if (_initHashtag) {
					selectedHasgTag = _.find(hashtags, { ID: _initHashtag });
					_initHashtag = '';
				}

				if (isOnline) {
					vm.onlineHashtags = hashtags;
					if (selectedHasgTag) {
						vm.onlineHashtag = [selectedHasgTag.ID];
					}
				} else {
					vm.hashtags = hashtags;
					if (selectedHasgTag) {
						vm.hashtag = [selectedHasgTag.ID];
					}
				}
			}
		}

		return vm;
	}
})(window);
